import { DatabaseEnum, DatabaseManager, ServiceProgramDatabase } from "@robotical/analytics-gatherer";
import serviceProgramFirebaseConfig from "./config";
import WarrantyServiceFacade from "@robotical/appv2-warranty-service-lib/dist/facade/WarrantyServiceFacade";

export default class ConsentManager {
    static async getDb() {
        try {
            const dbManager = DatabaseManager.getInstance();
            const dbInstance = await dbManager.initializeOrGetDatabase(
                DatabaseEnum.SERVICE_PROGRAM, serviceProgramFirebaseConfig, DatabaseEnum.SERVICE_PROGRAM
            ) as ServiceProgramDatabase;
            return dbInstance;
        } catch (e) {
            console.error("error getting db:", e);
            return null;
        }
    }

    static async setAutomatedFaultReportingConsent(email: string, consent: boolean) {
        try {
            const resultNew = await this.setAutomatedFaultReportingConsent_new(email, consent);
            const resultLegacy = await this.setAutomatedFaultReportingConsent_legacy(email, consent);
            return { resultNew, resultLegacy };
        } catch (error) {
            console.error("Error setting automated fault reporting consent:", error);
        }
        return false;
    }

    static async setAutomatedFaultReportingConsent_legacy(email: string, consent: boolean) {
        const db = await this.getDb();
        if (!db) {
            return;
        }
        return db.setAutomatedFaultReportingConsent(email, consent);
    }


    static async setAutomatedFaultReportingConsent_new(email: string, consent: boolean) {
        try {
            return WarrantyServiceFacade.setAutomatedFaultReportingConsent(email, consent)
        } catch (error) {
            console.error("Error setting automated fault reporting consent:", error)
            return false;
        }
    }

    static async setAnalyticsConsent(email: string, consent: boolean) {
        try {
            const resultNew = await this.setAnalyticsConsent_new(email, consent);
            const resultLegacy = await this.setAnalyticsConsent_legacy(email, consent);
            return { resultNew, resultLegacy };
        } catch (error) {
            console.error("Error setting analytics consent:", error);
        }
        return false;
    }

    static async setAnalyticsConsent_legacy(email: string, consent: boolean) {
        const db = await this.getDb();
        if (!db) {
            return;
        }
        return db.setAnalyticsConsent(email, consent);
    }

    static async setAnalyticsConsent_new(email: string, consent: boolean) {
        try {
            return WarrantyServiceFacade.setAnalyticsConsent(email, consent)
        } catch (error) {
            console.error("Error setting analytics consent:", error)
            return false;
        }
    }

}